import { Month } from "./Month.js";

export const getMonthName = (month: Month) => {
  if (month === "01") {
    return "Jaanuar";
  } else if (month === "02") {
    return "Veebruar";
  } else if (month === "03") {
    return "Märts";
  } else if (month === "04") {
    return "Aprill";
  } else if (month === "05") {
    return "Mai";
  } else if (month === "06") {
    return "Juuni";
  } else if (month === "07") {
    return "Juuli";
  } else if (month === "08") {
    return "August";
  } else if (month === "09") {
    return "September";
  } else if (month === "10") {
    return "Oktoober";
  } else if (month === "11") {
    return "November";
  } else if (month === "12") {
    return "Detsember";
  } else {
    throw new Error(`Invalid month: ${month}.`);
  }
};
